import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsDefined,
  IsObject,
  IsOptional,
  IsString
} from 'class-validator';

export class ChatRoleDto {
  @IsDefined()
  @IsString()
  name: string;

  @IsDefined()
  @IsBoolean()
  custom: boolean;

  @IsDefined()
  @IsArray()
  scopes: string[];

  @IsOptional()
  @IsDateString()
  created_at: string;

  @IsOptional()
  @IsDateString()
  updated_at: string;

  @IsOptional()
  @IsObject()
  grants?: Record<string, string[]>;
}
